import { Collection, VariantAxisPoint } from 'modules/collections';

export const getTotalAvailablePoints = (collection: Collection, type?: string) => {
  const acc: VariantAxisPoint[] = [];
  const collectionVariants = type
    ? collection.variants.filter(variant => variant.axisMeta.attribute === type)
    : collection.variants;
  collectionVariants.forEach(variant => {
    acc.push(...variant.pointsOnAxis);
  });
  return acc;
};

export const getSortedPoints = (collection: Collection, pointKey: 'size' | 'price', type?: string) => {
  if (pointKey === 'price') {
    return [...getTotalAvailablePoints(collection, type)].sort((a, b) => +a.price.price - +b.price.price);
  }

  return [...getTotalAvailablePoints(collection, type)].sort((a, b) => +a.size - +b.size);
}

// Элементы с характеристиками коллекции
export const getCollectionTypeRange = (collection: Collection) =>
  collection.variants.length > 1 ? 'Прямой и\u00A0угловой' : 'Прямой';

export const getCollectionSizeRange = (collection: Collection) => {
  const sortedPoints = getSortedPoints(collection, 'size');
  return sortedPoints.length > 1
    ? ` ${sortedPoints[0].size}\u2013${sortedPoints[sortedPoints.length - 1].size}\u00A0см`
    : ` ${sortedPoints[0].size}\u00A0см`;
};

export const getCheapestCollectionVariant = (collection: Collection, typeId: string | undefined) =>
  getSortedPoints(collection, 'price', typeId)[0];

export const getHighestCollectionVariant = (collection: Collection, typeId: string | undefined) => {
  const sortedPoints = getSortedPoints(collection, 'price', typeId);

  return sortedPoints[sortedPoints.length - 1];
};
